import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dirty: { type: Boolean, default: false }
  }

  connect() {
    this.element.addEventListener("submit", this.onSubmit)
    this.element.addEventListener("change", this.onChange)
    this.element.addEventListener("input", this.onChange)
    this.element.addEventListener("turbo:submit-end", this.onSubmitEnd)

    this.originalFormData = this.getFormData()

    this.enableConfirmation(this.dirtyValue)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.onSubmit)
    this.element.removeEventListener("change", this.onChange)
    this.element.removeEventListener("input", this.onChange)
    this.element.removeEventListener("turbo:submit-end", this.onSubmitEnd)
    this.enableConfirmation(false)
  }

  onChange = () => {
    if (this.dirtyValue) { return; }
    const currentFormData = this.getFormData()
    const hasChanged = currentFormData !== this.originalFormData
    this.enableConfirmation(hasChanged)
  }

  onSubmit = () => {
    this.enableConfirmation(false)
  }

  onSubmitEnd = (event) => {
    if (event.detail.success) {
      // Make sure the form's action wasn't changed by the submitter,
      // as in the case with the test button in the channels controller.
      const submitter = event.detail.formSubmission?.submitter
      if (!submitter || !submitter.hasAttribute("formaction")) {
        this.dirtyValue = false
        this.originalFormData = this.getFormData()
        this.enableConfirmation(false)
        return;
      }
    }

    this.dirtyValue = true
    this.enableConfirmation(true)
  }

  onBeforeUnload = (event) => {
    event.preventDefault()
    event.returnValue = ''
  }

  getFormData() {
    const formData = new FormData(this.element)
    const filteredData = new URLSearchParams()

    for (const [key, value] of formData.entries()) {
      if (key !== "authenticity_token" && key !== "utf8") {
        filteredData.append(key, value)
      }
    }

    return filteredData.toString()
  }

  enableConfirmation(value = true) {
    if (value) {
      document.documentElement.setAttribute("data-turbo", "false")
      window.addEventListener("beforeunload", this.onBeforeUnload)
    } else {
      document.documentElement.removeAttribute("data-turbo")
      window.removeEventListener("beforeunload", this.onBeforeUnload)
    }
  }
}
